import { WITHDRAWAL_AGGREGATOR_ID } from './withdrawal';
import {
  WithdrawalsCurrencies,
  WithdrawalsCurrency,
} from './withdrawals-currency';

export enum WITHDRAWALS_LIMIT_TYPE {
  ONCE = 1,
  DAILY = 2,
  MONTHLY = 3,
}

export type WithdrawalsLimitId = string;

export type WithdrawalsLimit = {
  id: WithdrawalsLimitId;
  aggregatorId: undefined | null | WITHDRAWAL_AGGREGATOR_ID;
  currency: undefined | WithdrawalsCurrency;
  minAmount: undefined | number;
  maxAmount: undefined | number;
  limitType: undefined | WITHDRAWALS_LIMIT_TYPE;
};

export type WithdrawalsLimits = WithdrawalsLimit[];

export type WithdrawalsLimitsRecord = Record<
  WithdrawalsLimitId,
  Omit<WithdrawalsLimit, 'id'>
>;

export type WithdrawalsLimitsList = {
  items: WithdrawalsLimitsRecord;
  currencies: WithdrawalsCurrencies;
  aggregatorIds: WITHDRAWAL_AGGREGATOR_ID[];
};
